import { HostProps } from './host-props';

export const HiroEntryService = Symbol('HiroEntryService');

export interface HiroBasicConfig {
    name: string;
    url: string;
    enabled: boolean;
    /** 开启的智能体 code */
    enabledAgentCodes: string[];
    /** 智能体配置, key 为智能体 code, value 为智能体配置 */
    agentConfigs: Record<string, {
        ai_filter_case?: Array<{
            task_id: string;
            label_key: string;
        }>;
        selected_limit?: number;
    }>;
}


/** 需要业务实现 */
export interface HiroEntryService {
    getHiroBasicConfig(): Promise<HiroBasicConfig>;

    getWujieProps(basicConfig: HiroBasicConfig): HostProps;
}
